import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function Problem() {
  const { t } = useTranslation();
  const [stats, setStats] = useState({ stat1: 0, stat2: 0, stat3: 0 });
  const sectionRef = useRef(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated.current) {
            hasAnimated.current = true;
            animateStats();
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const animateStats = () => {
    const duration = 2000;
    const targets = { stat1: 82, stat2: 71, stat3: 5 };
    const start = Date.now();

    const animate = () => {
      const elapsed = Date.now() - start;
      const progress = Math.min(elapsed / duration, 1);
      
      setStats({
        stat1: Math.floor(targets.stat1 * progress),
        stat2: Math.floor(targets.stat2 * progress),
        stat3: Math.floor(targets.stat3 * progress)
      });

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    animate();
  };

  return (
    <section className="section problem-section" id="problem" ref={sectionRef}>
      <div className="container">
        <span className="section-label">{t('problem.label')}</span>
        <h2 className="section-title">{t('problem.title')}</h2>

        <p className="conclusion-text"><strong>
          {t('problem.conclusion')}<br/>
          {t('problem.conclusion2')}
        </strong></p>

        <div className="stats-grid">
          <div className="stat-box animate-on-scroll">
            <div className="stat-number">{stats.stat1}%<sup>1</sup></div>
            <p className="stat-description">{t('problem.stat1')}</p>
          </div>
          <div className="stat-box animate-on-scroll">
            <div className="stat-number">{stats.stat2}%<sup>2</sup></div>
            <p className="stat-description">{t('problem.stat2')}</p>
          </div>
          <div className="stat-box animate-on-scroll">
            <div className="stat-number">{stats.stat3}%<sup>3</sup></div>
            <p className="stat-description">{t('problem.stat3')}</p>
          </div>
        </div>
        <div className="sources">
          <ol className="sources-list">
            <li><span className="source-number">1.</span> {t('problem.source1')}</li>
            <li><span className="source-number">2.</span> {t('problem.source2')}</li>
            <li><span className="source-number">3.</span> {t('problem.source3')}</li>
          </ol>
        </div>

      </div>
    </section>
  );
}

export default Problem;
